<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">申请单号</label>
            <em class="weui-form-preview__value">{{ form.main.aa_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="aa_em_name">
            <label class="weui-form-preview__label">{{customLabel.aa_em_name || "申请人"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.aa_em_name
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="aa_em_code">
            <label class="weui-form-preview__label">{{customLabel.aa_em_code || "申请人编号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.aa_em_code
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="aa_role_name">
            <label class="weui-form-preview__label">{{customLabel.aa_role_name || "岗位名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.aa_role_name
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="aa_department">
            <label class="weui-form-preview__label">{{customLabel.aa_department || "部门名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.aa_department
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="aa_module_name">
            <label class="weui-form-preview__label">{{customLabel.aa_module_name || "模块名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.aa_module_name
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="aa_group_name">
            <label class="weui-form-preview__label">{{customLabel.aa_group_name || "单据名称"}}</label>
            <span
              class="weui-form-preview__value"
              >{{ form.main.aa_group_name }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="aa_resource_name">
            <label class="weui-form-preview__label">{{customLabel.aa_resource_name || "操作"}}</label>
            <span
              class="weui-form-preview__value"
              >{{ form.main.aa_resource_name }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="aa_content">
            <label class="weui-form-preview__label">{{customLabel.aa_content || "申请内容"}}</label>
            <span
              class="weui-form-preview__value"
              >{{ form.main.aa_content }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="aa_reason">
            <label class="weui-form-preview__label">{{customLabel.aa_reason || "申请原因"}}</label>
            <span
              class="weui-form-preview__value"
              >{{ form.main.aa_reason }}</span
            >
          </div>
        </custom-layout>
      </div>

       <file-list v-model="form.main.aa_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
    
      <router-link
        :to="'/oa/auth_apply_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_unaudit"
        >反审</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_remove"
        >删除</a
      >
      <share
        class="weui-dialog__btn weui-dialog__btn_default"
        v-if="!editable"
        :biz-data="bizData"
      ></share>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import Share from "@/components/button/Share.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    Share,
  },
  data() {
    return {
      baseUrl: "/api/oa/authApply",
      codeField: "aa_code",
      statusField: "aa_statuscode",
      caller: "AuthApply",
      xtype: "oa-authApply-formpanel",
      form: {
        main: {},
        items: [],
      },
    };
  },
  computed: {
    bizData() {
      var main = this.form.main;
      if (!main) {
        return null;
      }
      return {
        bizCode: main.aa_code,
        bizType: "AuthApply",
        bizId: main.id,
        viewType: "oa-authApply-formpanel",
        title: "权限申请" + main.ec_code,
      };
    },
  },
  methods: {
    
  },
};
</script>